module.exports = __webpack_public_path__ + "img/pure_waste.7785060b.png";